var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevOpsMigration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1298_5001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.999 16.9995V34.9995H0.999023V16.9995H22.999Z",
    stroke: "#D41E4D",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.999 16.9995V34.9995H33.999V16.9995H56.999Z",
    stroke: "#D41E4D",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999023 34.9995V51.9995H22.999V34.9995H0.999023Z",
    stroke: "#D41E4D",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.999 34.9995V51.9995H56.999V34.9995H33.999Z",
    stroke: "#D41E4D",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99902 22.9995H7.99902",
    stroke: "#D41E4D",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.999 25.9995H40.999",
    stroke: "#D41E4D",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99902 39.9995H7.99902",
    stroke: "#D41E4D",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.999 42.9995H40.999",
    stroke: "#D41E4D",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99902 25.9995H17.999",
    stroke: "#D41E4D",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.999 25.9995H51.999",
    stroke: "#D41E4D",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99902 42.9995H17.999",
    stroke: "#D41E4D",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.999 42.9995H51.999",
    stroke: "#D41E4D",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4694 11.9131C19.5626 10.2484 21.0529 8.88198 22.8059 7.93699C24.5589 6.99201 26.5196 6.49817 28.511 6.5C30.5025 6.50184 32.4623 6.99928 34.2136 7.9475C35.9648 8.89571 37.4526 10.2649 38.5427 11.9315",
    stroke: "#D41E4D",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1298_5001"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevOpsMigration);
export default __webpack_public_path__ + "static/media/DevOps_Migration.1e5fc78ff4448c78303a007b5cca4d02.svg";
export { ForwardRef as ReactComponent };